/**
 * orgDuties — shared helper for "which orgs does this user actively belong
 * to" (2026-07-08). Feeds the general org-guidelines Notice (Action Center)
 * and its LeftNav badge contribution, so both surfaces compute the same set.
 * Excludes personal Workshops (entity_type 'organization' with a
 * personal_owner back-link — never a duty source).
 */

export function computeActiveOrgGuids(
  currentUserGuid: string | null | undefined,
  communityMemberships: Record<string, any>[] | undefined,
  communityEntities: Record<string, any>[] | undefined,
): string[] {
  const me = String(currentUserGuid || "").toUpperCase();
  if (!me) return [];

  const typeByGuid = new Map<string, string>();
  const personalOwned = new Set<string>();
  for (const c of communityEntities || []) {
    const g = String(c.entity_guid || c.entityGuid || "").toUpperCase();
    if (!g) continue;
    typeByGuid.set(g, String(c.entity_type || c.entityType || "").toLowerCase());
    if (c.personal_owner_user_guid || c.personalOwnerUserGuid) personalOwned.add(g);
  }

  const out = new Set<string>();
  for (const m of communityMemberships || []) {
    if (String(m.user_guid || "").toUpperCase() !== me) continue;
    if (String(m.status || "active").toLowerCase() !== "active") continue;
    const g = String(m.community_entity_guid || "").toUpperCase();
    if (!g || personalOwned.has(g)) continue;
    const et = typeByGuid.get(g) || "";
    if (et === "organization" || et.startsWith("org_")) out.add(g);
  }
  return Array.from(out);
}
